import { useParams } from "react-router-dom";
import { useQueryString } from "@/hooks";
import { resolvePartnerSlug } from "./resolve_partner_slug";

// One name for the key, so a read and a write cannot drift apart.
const PARTNER_SLUG_STORAGE_KEY = "partnerSlug";

export const readStoredPartnerSlug = () =>
  localStorage.getItem(PARTNER_SLUG_STORAGE_KEY);

export const storePartnerSlug = (partnerSlug: string) =>
  localStorage.setItem(PARTNER_SLUG_STORAGE_KEY, partnerSlug);

interface PartnerSlugParams {
  partnerSlug?: string;
}

// The single place the portal decides which partner a page is for. Gathering the
// sources here rather than at each page keeps one precedence rule in play; the
// ordering itself lives in resolvePartnerSlug, which is unit-tested.
export function usePortalPartnerSlug(): string | undefined {
  const params = useParams<PartnerSlugParams>();
  const query = useQueryString<PartnerSlugParams>();

  return resolvePartnerSlug({
    fromPath: params.partnerSlug,
    fromQuery: query.partnerSlug,
    fromStorage: readStoredPartnerSlug(),
  });
}
